import React from "react";
import Dashboard from "../../components/Dashboard/Dashboard";

const DashboardMain = () => {
  return (
    <div>
      <Dashboard />
    </div>
  );
};

export default DashboardMain;
